import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { projectConfig, loginConfig } from '../../environments/environment';


@Injectable({
  providedIn: 'root',
})
export class AwsSecretsService {
  private config: any;
  public apiURL: string = projectConfig.apiURL;

  constructor(private http: HttpClient) {}

  loadSecrets(): Promise<void> {
    return new Promise<void>((resolve, reject) => {
      if(loginConfig.Client_ID && loginConfig.Tenant_ID) {
        resolve();
      } else {
      this.http
        .get<ConfigResponse>(this.apiURL + 'auth/get_config')
        .subscribe({
          next: (res) => {
            if (res?.status_code === 200) {
              this.config = res.data;
  
              // Map secrets to environment variables
              this.mapSecretsToEnvironment();
            }
            resolve(); // Correct - no argument required
          },
          error: (error) => {
            console.error('S-Error:');
            reject(error); // Pass error on rejection
          },
          complete: () => {
            console.log('S-Success');
          },
        });
      }
    });
  }

  getConfig(key: string) {
    return this.config[key];
  }

  // Dynamically map secrets to environment.ts
  private mapSecretsToEnvironment(): void {
    if (this.config) {
        loginConfig.Client_ID =  this.config['client_id']
        loginConfig.Tenant_ID =  this.config['tenant_id']
    }
  }

}


export interface ConfigResponse {
    message: string;
    data: {
      client_id: string;
      tenant_id: string;
    };
    status_code: number;
}
  